// Equal Heights
$(window).load(function(){
    checkWidth();
});

// hCaptcha
var companyVars = JSON.parse(document.getElementById("companyVars").innerText),
    asset_url = companyVars.assetUrl,
    website_base_url = companyVars.website_base_url,
    ir_base_url = companyVars.ir_base_url,
    hCaptchaSiteKey = companyVars.hCaptchaSiteKey,
    isQmod = companyVars.isQmod;

// hCaptcha
var captchaIDs = {}; // Holds all hCaptcha elements so that we can use the correct response when there are multiples on a page
function hCaptchaOnLoad () {
    // Add hcaptcha to all forms on a page
     $('.h-captcha').each(function () {
        var form = $(this).closest('form');
        window.captchaIDs[form[0].id] = hcaptcha.render(this.id, {
            "sitekey" : window.hCaptchaSiteKey,
            "callback": function (token) {
                $('<input>', {
                    type: 'hidden',
                    name: 'h-captcha-response',
                    value: token
                }).appendTo(form);
                form.submit();
            }
        });
    }); 
}

$(document).ready(function() {
    $('.mobile-nav-trigger').click(function(){
        $('.main-nav').css('height', 'auto');
    });
                $('.transitions').each(function() {
        $('.transition', this).each(function(i, e) {
            $(this).addClass('t-' + (i + 1));
        });
    });
    
        // Fade in divs when they appear
    // $('.trigger-fade-in').waypoint(function(event, direction) {
    //     $(this).addClass('in ready');
    // }, {
    //     offset: function() {
    //         // quarter of the element is in view
    //         return $.waypoints('viewportHeight') - ($(this).outerHeight() /
    //             4);
    //     }
    // });
    
    $('.trigger-fade-in').addClass('in ready');

    // Basic Form Validation
    var validator = $(".validate-form");
    validator.each(function () {
        var $form = $(this);
        var formID = $form.attr('id');
        $(this).validate({
            rules: {
                password_confirm: {
                    equalTo: "#password",
                    messages: {
                        equalTo: "Passwords must be the same"
                    }
                }
            },
            errorPlacement: function (error, element) {
                error.appendTo(element.parent());
            },
            submitHandler: function (form) {
                if (hcaptcha.getResponse(window.captchaIDs[formID])) {
                    form.submit();
                } else {
                    hcaptcha.reset(window.captchaIDs[formID]);
                    hcaptcha.execute(window.captchaIDs[formID]);
                }
            }
        });
    });    

    $('.background').each(function(){
        var bg = $(this).data('background'),
        color  = $(this).data('color');
        if (bg !== '' && bg !== undefined) {
            $(this).css("background-image", "url(" + bg + ")");
        }
        if (color !== '') {
            $(this).css("background-color", color);
        }
    });

    // Fancybox
    $('.fancybox').fancybox({
        helpers: {
            overlay: {
              locked: false
            }
          },
        minHeight: '600'
    });

    $('.spr-ir-pagination ul').addClass('pagination');
    $('.spr-ir-pagination').removeAttr('style').removeClass('spr-ir-pagination');

});

    var menuRight = document.getElementById('mobile-nav'),
        showRight = document.getElementById('showRight'),
        body = document.body;
    showRight.onclick = function() {
        classie.toggle(this, 'active');
        $('body').toggleClass('push-to-left');
        classie.toggle(menuRight, 'cbp-spmenu-open');
        disableOther('showRight');
    };

    function disableOther(button) {
        if (button !== 'showRight') {
            classie.toggle(showRight, 'disabled');
        }
    }

$('.toggle-button').click(function(){
    $(this).toggleClass("open");
});

// SEC Filings Quick Filter
$('.spr-ir-sec-filters table tr:first-child').prepend(
    $.makeArray(
        $('#sub-navigation li.child-active ul li a').map(function(i, a) {
            return '<td class="quick-filter"><a class="btn" href="' + a.href + '">' + $(a).text() + '</a></td>';
        })
    ).join("")
);

var pathname = window.location.pathname;
$('.quick-filter a').each(function (index) {
    var url = $(this).attr('href').split('/');
    url = url[url.length-1];
    match_url = document.location.pathname.split('/');
    match_url = match_url[match_url.length-1];
    if (url == match_url) {
        $(this).addClass("active");
    }
});

// Quote Box
function populateQuoteBox(quote) {
    $('.ir-quote-box .time').html('<time />');
    $('.ir-quote-box .time time').attr('date-time',quote.last_trade_time).html(quote.last_trade_time);
    $('.ir-quote-box .price .value').html('$' + quote.last);
    if (quote.volume == 'N/A') {
        $('.ir-quote-box .volume .value').html(quote.volume);
    } else {
        var html = $('.ir-quote-box .volume .value').html(quote.volume).digits();
    }
    if (quote.market_cap == 'N/A') {
        $('.ir-quote-box .market-cap').remove();
    } else {
        $('.ir-quote-box .market-cap .value').html('$' + quote.market_cap);
    }
    var change = quote.change.replace('-','').replace('+','');
    if (quote.change != 'N/A' && parseFloat(change) != 0) {
        $('.ir-quote-box .change .value').html('<span class="eqicon-arrow"></span> ' + ' $' + change);
        
        if (quote.change.indexOf('+') > -1 && (quote.change != '+0.00') && (quote.change != '0.00')) {
            $('.ir-quote-box .change').addClass('up');
        } else if (quote.change.indexOf('-') > -1) {
            $('.ir-quote-box .change').addClass('down');
        }
    }else {
        $('.ir-quote-box .change').remove();
        $('.stock-section.col-md-4').removeClass('col-md-4 col-sm-6').addClass('col-md-6 col-sm-12');
        $('.market-cap-value').removeClass('col-md-3 col-sm-6').addClass('col-md-4 col-sm-12');
    }
    var week = quote.low + ' - ' + quote.high;
    $('.week-range .value').html(week);
    if( quote.day_low != 'N/A' && quote.day_high != 'N/A') {
        if( quote.day_low == quote.day_high) {
            var day = quote.day_low;
        }else {
            day = quote.day_low + ' - ' + quote.day_high;
        }
        $('.day-range .value').html(day);
    }else {
        $('.day-range .value').html(quote.last);
    }
    
    $('.stock-date').html(quote.last_trade_time);
}

function abbrNum(number, decPlaces) {
    var orig = number;
    var dec = decPlaces;
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);

    // Enumerate number abbreviations
    var abbrev = ["K", "M", "B", "T"];

    // Go through the array backwards, so we do the largest first
    for (var i = abbrev.length - 1; i >= 0; i--) {

        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);

        // If the number is bigger or equal do the abbreviation
        if (size <= number) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            number = Math.round(number * decPlaces / size) / decPlaces;

            // Handle special case where we round up to the next abbreviation
            if((number == 1000) && (i < abbrev.length - 1)) {
                number = 1;
                i++;
            }

            // console.log(number);
            // Add the letter for the abbreviation
            number += abbrev[i];

            // We are done... stop
            break;
        }
    }

    //console.log('abbrNum('+ orig + ', ' + dec + ') = ' + number);
    return number;
}

// Add commas to numbers
$.fn.digits = function(){ 
    return this.each(function(){ 
        $(this).text( $(this).text().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") ); 
    });
};

//Smooth scroll to
function goToByScroll(id) {
    $('html,body').animate( {
        scrollTop: $(id).offset().top
    },'slow');
}
$('.smooth').click(function(){
    goToByScroll($(this).attr('href'));
    return false;
});

//Check Width
$(window).resize(function() {
    checkWidth();
});

function checkWidth() {
    if ($(window).width() > 767) {
        $('.same-height, .same-height-row').each(function() {
            $(this).addClass('active');
        });
        sameHeight();
    } else {
        $('.same-height, .same-height-row').each(function() {
            $(this).removeClass('active');
        });
        $(".same-height,.same-height-row .height").css('min-height',0);
    }
    if ($(window).width() < 769) {
        $('.fancybox').each(function(){
            $(this).addClass('fancybox-holder').attr('target', '_blank').removeClass('fancybox');
        });
        $('.thickbox').each(function(){
            $(this).addClass('thickbox-holder').attr('target', '_blank').removeClass('thickbox');
        });
    } else {
        $('.fancybox-holder').each(function(){
            $(this).addClass('fancybox').removeAttr('target').removeClass('fancybox-holder');
        });
        $('.thickbox-holder').each(function(){
            $(this).addClass('thickbox').removeAttr('target').removeClass('thickbox-holder');
        });
    }

}
// Same Height
function sameHeight() {
    $('.height').each(function(){}).css('min-height', 0);
    var $contentHeight = $('.general-content').outerHeight();
    $('.full-height').each(function() {
        $(this).css('min-height', $contentHeight + 10);
    }); 
    
    var maxHeight = 0;
    $(".same-height.active").each(function() {
        if ($(this).outerHeight() > maxHeight) {
            maxHeight = $(this).outerHeight();
        }
    }
    ).css('min-height',maxHeight);

    $(".same-height-row.active").each(function() {
        var maxHeight = 0;
        $('.height', this).each(function() {
            if ($(this).outerHeight() > maxHeight) {
                maxHeight = $(this).outerHeight();
            }
        }).css('min-height',maxHeight);
    });
}

$(document).ajaxComplete(function() {
    checkWidth();
});